import React from "react"
import Banner from "../../containers/banner"
import About from "../../containers/about"
import Layout from "../../containers/layout";
import { Container, Row, Col } from 'reactstrap';
import { Titlespan2 } from '../../components/title/index';
import AfterBanner from '../../containers/after-banner';

const IndexPage = () => {
    return (
        <Layout>
            <Banner ChangeClass={'demo1'} title="Industry Sectors" body={(
                <>
                    <h3>Consumers</h3>
                    <p><a className="text-white" href="/sectors">Back to sectors</a></p>
                </>
            )}/>
            <AfterBanner size={9} title="" subtitle="Overview">
                <table className="table">
                    <tr>
                        <td>
                            <strong>eWallet</strong><br/>
                            Create a free eWallet and enjoy quick and easy payments.
                        </td>
                        <td>
                            <strong>Add Funds</strong><br/>
                            Conveniently fund your wallet based on your preference from our multiple funding options: Direct debit, Online banking, Exchange house, Bank transfer, Debit/Credit card(s).
                        </td>
                        <td>
                            <strong>Manage Accounts</strong><br/>
                            In addition to eWallet account, you can link your eWallet with your Debit/ Credit card(s) and set any of your account(s)as primary mode of payment.
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <strong>Payment</strong><br/>
                            Make instant, secure payment from our multiple payment channels: eWallet, Direct debit, eVoucher, Credit/Direct cards.
                        </td>
                        <td>
                            <strong>Dashboard</strong><br/>
                            Get a clear insight into your spending from payment history, top-up summary and account statement reports.
                        </td>
                        <td>
                            <strong>Xpress Payments</strong><br/>
                            Link your merchant details in your wallet and pay with just one click. Set daily payment limit for each merchant.
                        </td>
                    </tr>
                </table>

            </AfterBanner>
        </Layout>
    )
}

export default IndexPage
